import React, { useCallback, useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../contexts";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../utils/api";
import {
	ActiveEnrollmentStatus,
	ActiveIntercityEnrollmentStatus,
	ActivePanhandleEnrollmentStatus,
	ActiveProgressiveLabsEnrollmentStatus,
	EnrollmentSchema
} from "../../../types/enrollment.types";
import HealthCard from "./BBIHealthCard/HealthCard";
import IntercityHealthCard from "./IntercityHealthCard/IntercityHealthCard";
import { HealthCardNotActive } from "../../shared";
import { GROUP_NUMBER } from "../../../constants/groupNumber/groupNumber";
import ClinicCard from "./BBIClinicCard/ClinicCard";
import BOPHealthCard from "./BOPHealthCard/BOPHealthCard";
import ProgressiveLabHealthCard from "./ProgressiveLabHealthCard/ProgressiveLabHealthCard";
import TestGroupHealthCard from "./TestGroupHealthCard/TestGroupHealthCard";
//
const RedirectionHealthCard = () => {
	const [activeEnrollmentStatus, setActiveEnrollmentStatus] = useState<
		ActiveEnrollmentStatus | ActiveIntercityEnrollmentStatus | ActiveProgressiveLabsEnrollmentStatus | null
	>(null);
	const { member } = useContext(AuthContext);

	const getActiveEnrollmentStatus = useCallback(
		(activeEnrollments: EnrollmentSchema[]) => {
			const _activeBBIEnrollmentStatus = {
				"Health Plan": false,
				"Clinic Card": false,
				KSOP: false,
				"Group Short Term Disability": false,
				"Group Long Term Disability(Class 1)": false,
				"Group Long Term Disability(Class 2)": false,
				"Group Life Insurance": false,
				"Helping Our Own": false,
				"Christmas Club Election": false
			};

			const _activeICIEnrollmentStatus = {
				"Health Plan": false,
				"Flex Med": false,
				"Flex Care": false,
				"Group Long Term Disability": false,
				"Group Life Insurance(Free)": false,
				"Group Life Insurance(Optional)": false
			};

			const _activeProgressiveLabsEnrollmentStatus = {
				"Health Plan": false
			};

			const _activePanhandleFirstBankEnrollmentStatus = {
				"Health Plan": false,
				"Dental Plan": false,
				"Vision Plan": false
			};

			if (member?.group_number === GROUP_NUMBER.Brookshire_Brothers) {
				Object.entries(_activeBBIEnrollmentStatus).forEach(([planName, value], index) => {
					activeEnrollments.forEach((activeEnrollment: EnrollmentSchema) => {
						const { enrollment_status, plan_name } = activeEnrollment;
						if (plan_name === planName) {
							_activeBBIEnrollmentStatus[planName as keyof ActiveEnrollmentStatus] = true;
						}
					});
				});
				setActiveEnrollmentStatus(Object.assign({}, _activeBBIEnrollmentStatus));
			} else if (member?.group_number === GROUP_NUMBER.Intercity_Investment) {
				Object.entries(_activeICIEnrollmentStatus).forEach(([planName, value], index) => {
					activeEnrollments.forEach((activeEnrollment: EnrollmentSchema) => {
						const { enrollment_status, plan_name } = activeEnrollment;
						if (plan_name === planName) {
							_activeICIEnrollmentStatus[planName as keyof ActiveIntercityEnrollmentStatus] = true;
						}
					});
				});
				setActiveEnrollmentStatus(Object.assign({}, _activeICIEnrollmentStatus));
			} else if (member?.group_number === GROUP_NUMBER.Progressive_Laboratories) {
				Object.entries(_activeProgressiveLabsEnrollmentStatus).forEach(([planName, value], index) => {
					activeEnrollments.forEach((activeEnrollment: EnrollmentSchema) => {
						const { enrollment_status, plan_name } = activeEnrollment;
						if (plan_name === planName) {
							_activeProgressiveLabsEnrollmentStatus[
								planName as keyof ActiveProgressiveLabsEnrollmentStatus
							] = true;
						}
					});
				});
				setActiveEnrollmentStatus(Object.assign({}, _activeProgressiveLabsEnrollmentStatus));
			} else if (member?.group_number === GROUP_NUMBER.Test_Group) {
				Object.entries(_activeProgressiveLabsEnrollmentStatus).forEach(([planName, value], index) => {
					activeEnrollments.forEach((activeEnrollment: EnrollmentSchema) => {
						const { enrollment_status, plan_name } = activeEnrollment;
						if (plan_name === planName) {
							_activeProgressiveLabsEnrollmentStatus[
								planName as keyof ActiveProgressiveLabsEnrollmentStatus
							] = true;
						}
					});
				});
				setActiveEnrollmentStatus(Object.assign({}, _activeProgressiveLabsEnrollmentStatus));
			} else if (member?.group_number === GROUP_NUMBER.Panhandle_First_Bank) {
				Object.entries(_activePanhandleFirstBankEnrollmentStatus).forEach(([planName, value], index) => {
					activeEnrollments.forEach((activeEnrollment: EnrollmentSchema) => {
						const { enrollment_status, plan_name } = activeEnrollment;
						if (plan_name === planName) {
							_activePanhandleFirstBankEnrollmentStatus[
								planName as keyof ActivePanhandleEnrollmentStatus
							] = true;
						}
					});
				});
				setActiveEnrollmentStatus(Object.assign({}, _activePanhandleFirstBankEnrollmentStatus));
			}
		},
		[member?.group_number]
	);

	const getInitEnrollmentData = useCallback(async () => {
		const { openEnrollments, dependents, enrollments, activeEnrollments } = await trackPromise(
			api.pages.getEnrollmentInitData()
		);
		getActiveEnrollmentStatus(activeEnrollments);
	}, [getActiveEnrollmentStatus]);

	useEffect(() => {
		getInitEnrollmentData();
	}, [getInitEnrollmentData]);

	// console.log("redirecting ", activeEnrollmentStatus);
	if (activeEnrollmentStatus === null) return <div>Loading...</div>;
	return (
		<>
			{/* {activeEnrollmentStatus?.["Health Plan"] === true ? (
				member?.group_number === GROUP_NUMBER.Brookshire_Brothers ? (
					<HealthCard />
				) : member?.group_number === GROUP_NUMBER.Intercity_Investment ? (
					<IntercityHealthCard />
				) : null
			) : (
				<HealthCardNotActive />
			)} */}

			{activeEnrollmentStatus?.["Health Plan"] === true ||
			(activeEnrollmentStatus &&
				"Clinic Card" in activeEnrollmentStatus &&
				activeEnrollmentStatus["Clinic Card"] === true) ? (
				member?.group_number === GROUP_NUMBER.Brookshire_Brothers ? (
					activeEnrollmentStatus?.["Health Plan"] ? (
						<HealthCard />
					) : (
						<ClinicCard />
					)
				) : member?.group_number === GROUP_NUMBER.Intercity_Investment ? (
					<IntercityHealthCard />
				) : member?.group_number === GROUP_NUMBER.Panhandle_First_Bank ? (
					<BOPHealthCard />
				) : member?.group_number === GROUP_NUMBER.Progressive_Laboratories ? (
					<ProgressiveLabHealthCard />
				) : member?.group_number === GROUP_NUMBER.Test_Group ? (
					<TestGroupHealthCard />
				) : null
			) : (
				<HealthCardNotActive />
			)}
		</>
	);
};

export default RedirectionHealthCard;
